<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-reportdate></create-reportdate>
    </div>
  </div>
</template>

<script>
import CreateReportdate from "../../components/CreateReportdate.vue";

export default {
  components: {
    CreateReportdate
  },
  name: "Reportdate",
  data() {
    return {
      items: [],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {}
};
</script>
<style></style>
